import * as Sentry from "@sentry/nextjs";

type LogContext = {
  extra?: Record<string, any>;
  tags?: Record<string, string>;
};

// Safely convert any caught value to an Error object
function ensureError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }
  return new Error(typeof error === "object" ? JSON.stringify(error) : String(error));
}

export function logError(error: unknown, context?: LogContext): string {
  const errorObject = ensureError(error);
  return Sentry.captureException(errorObject, context);
}

export function logMessage(message: string, context?: LogContext): string {
  return Sentry.captureMessage(message, context);
}
